// extracted by mini-css-extract-plugin
export default {"formSection":"styles_formSection__EBmrY","instruction":"styles_instruction__G+7iy","optionsContainer":"styles_optionsContainer__D4ddf","radio-label":"styles_radio-label__x04LS"};